import subjectsActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  query: createAsyncRequestReducer(subjectsActionTypes.SEARCH_SUBJECTS),
};

export default combineReducers(reducers);
